// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1UserAccountPropertiesUpdateSchema } from './v1/userAccountProperties/updateSchema';
import { v1UserAccountPropertySchema } from './v1/userAccountPropertySchema';

export const modifyUserAccountPropertiesPathParamsSchema = z.object({
  account_id: z.number().int().describe("Workspace id"),
  user_id: z.number().int().describe("User id"),
});

export const modifyUserAccountPropertiesHeaderParamsSchema = z.object({
  Authorization: z.coerce.string(),
});

/**
 * @description Modified user account property values
 */
export const modifyUserAccountProperties200Schema = z.array(z.lazy(() => v1UserAccountPropertySchema));

export const modifyUserAccountPropertiesMutationRequestSchema = z.lazy(() => v1UserAccountPropertiesUpdateSchema);

export const modifyUserAccountPropertiesMutationResponseSchema = z.lazy(() => modifyUserAccountProperties200Schema);
